import { svg } from "config/svgStyles";

export const closeButton = ({ isMobile }) => ({
  display: "flex",
  flexDirection: "row",
  color: "primary",
  alignItems: "center",
  border: "none",
  cursor: "pointer",
  fontFamily: "body",
  fontWeight: "light",
  fontSize: isMobile ? "20px" : "30px",
  justifyContent: "center",
  lineHeight: "1",
  letterSpacing: "0.025em",
  whiteSpace: "nowrap",

  "> svg": {
    marginLeft: "10px",
    height: isMobile ? "16px" : "24px",
    width: isMobile ? "16px" : "24px",

    ...svg("primary"),
  },
});
